import React from 'react';

import { useTrackingStatus } from '../../../features/tracking/components/functional/useTrackingStatus';
import { ProgressBarStep } from '../../ProgressBar/ProgressBarStep';
import classNames from 'classnames';

import './Tab.scss';

interface TabProps {
  id: string;
  value: string;
  selected: boolean;
  onClick: () => void;
  hideLabel?: boolean;
}

export const Tab: React.FC<TabProps> = ({ id, value, selected, onClick, hideLabel }) => {
  const { isComplete } = useTrackingStatus(id);

  return (
    <div
      onClick={onClick}
      className={classNames('tab', {
        'tab--finished': isComplete,
        'tab--selected': selected,
      })}
    >
      {!hideLabel && <div className="tab__text">{value}</div>}
      <div className={classNames({ 'tab-progress-bar--margin': hideLabel })}>
        <ProgressBarStep id={id} selected={selected} disabled={false} />
      </div>
    </div>
  );
};
